import * as XLSX from "xlsx";
import { formatTgl } from "./LaporanUtils.js";

/**
 * Export data laporan (array hasil flattenLaporan dari LaporanUtils)
 * ke file .xlsx dengan kolom persis seperti tabel "Laporan Pengujian".
 *
 * Field flattenLaporan (sumber kebenaran):
 *   nm_upi, nm_jenis_uji, tgl_contoh, tgl_sur, tgl_lhu, tmp_uji,
 *   kategori, nm_uji, result, satuan, methode, lod_loq, keterangan
 * Fallback lama (parameter_uji/hasil_uji, tgl_ambil_contoh, nm_lab, ...)
 * tetap didukung agar pemanggil lama tidak pecah.
 */
const pick = (...vals) => vals.find((v) => v !== undefined && v !== null && v !== "") ?? "-";

export function exportLaporanToExcel(flatRows, { fileName = "Laporan_Pengujian" } = {}) {
    const rows = Array.isArray(flatRows) ? flatRows : [];
    const sheetData = rows.map((r) => ({
        "No. ID": pick(r.id_lab),
        "Nama UPI": pick(r.nm_upi),
        "Nama Produk": pick(r.nm_jenis_uji, r.nm_produk),
        "Tanggal Pengambilan Contoh Oleh Inspektur": formatTgl(pick(r.tgl_contoh, r.tgl_ambil_contoh, null) === "-" ? null : (r.tgl_contoh ?? r.tgl_ambil_contoh)),
        "Tanggal Contoh diterima oleh Laboratorium Penguji": formatTgl(pick(r.tgl_sur, r.tgl_terima_lab, null) === "-" ? null : (r.tgl_sur ?? r.tgl_terima_lab)),
        "Tanggal Terbit LHU": formatTgl(pick(r.tgl_lhu, null) === "-" ? null : r.tgl_lhu),
        "Kategori Pengujian (Biologi/Kimia/Fisik)": pick(r.kategori),
        "Parameter Uji": pick(r.nm_uji, r.parameter_uji),
        "Hasil Uji": pick(r.result, r.hasil_uji),
        Satuan: pick(r.satuan),
        "Metode Uji": pick(r.methode, r.metode),
        "LOD/LOQ": pick(r.lod_loq),
        Keterangan: pick(r.keterangan),
        "Nama Laboratorium Penguji": pick(r.tmp_uji, r.nm_lab),
    }));

    const ws = XLSX.utils.json_to_sheet(sheetData);
    ws["!cols"] = Object.keys(sheetData[0] || { _: 1 }).map(() => ({ wch: 22 }));

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Laporan Pengujian");

    const tanggal = new Date().toISOString().slice(0, 10);
    XLSX.writeFile(wb, `${fileName}_${tanggal}.xlsx`);
}

export function filterLaporan(flatRows, { dari, sampai, nmUpi }) {
    const rows = Array.isArray(flatRows) ? flatRows : [];
    return rows.filter((r) => {
        const tgl = r.tgl_contoh ?? r.tgl_ambil_contoh;
        let ok = true;
        if (dari && tgl) ok = ok && new Date(tgl) >= new Date(dari);
        if (sampai && tgl) ok = ok && new Date(tgl) <= new Date(sampai);
        if (nmUpi) ok = ok && String(r.nm_upi ?? "").toLowerCase().includes(nmUpi.toLowerCase());
        return ok;
    });
}
